export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/shopping-bag-confetti.6238848f.svg","height":50,"width":43};